module.exports = __webpack_public_path__ + "img/Newbie_Shield_03_Classic.256144e7.png";